/**
 * Underline-style text input with floating label and optional validation hint for GuardRails forms.
 * @module Workspace/components/GuardRailsSelectorModal/components/FloatingTextField
 */
import React from 'react';
import PropTypes from 'prop-types';
import {
  FloatingFieldWrapper,
  FloatingFieldInput,
  FloatingFieldLabel,
} from 'Workspace/components/GuardRailsSelectorModal/styles';

/**
 * @param {object} props
 * @param {string} props.id
 * @param {string} props.name - Form field name; forwarded to input.
 * @param {string} props.label
 * @param {string} [props.value]
 * @param {(e: { currentTarget: { value: string, name: string } }) => void} [props.onChange]
 * @param {boolean} [props.required]
 * @param {number} [props.fontSize]
 * @param {boolean} [props.error] - When true, shows a required hint below the field.
 * @param {boolean} [props.fullWidth]
 * @param {number} [props.marginBottom]
 */
function FloatingTextField(props) {
  const { id, name, label, value, onChange, required, fontSize, error, fullWidth, marginBottom, ...rest } = props;
  const placeholderText = required ? `${label} (Required)` : label;

  return (
    <FloatingFieldWrapper fullWidth={fullWidth} marginBottom={marginBottom}>
      <FloatingFieldInput
        id={id}
        name={name}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholderText}
        fontSize={fontSize}
        required={required}
        {...rest}
      />
      <FloatingFieldLabel htmlFor={id}>{label}</FloatingFieldLabel>
      {error && <span style={{ color: '#f44336', fontSize: 12, marginTop: 4, display: 'block' }}>Required</span>}
    </FloatingFieldWrapper>
  );
}

FloatingTextField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  fontSize: PropTypes.number,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  marginBottom: PropTypes.number,
};

export default FloatingTextField;
